export interface SalesDespatchItemDetails {
  id: string;
  stockNo: string;
  productKey: string;
  productDescription: string;
  invoicePrice: number;
  freeOfChargeQty: number;
  grossQuantity: number;
  nettQuantity: number;
  convertedQuantity: number;
  selected: boolean;
  canDelete: boolean;
}
